import { useImmer } from 'use-immer';
import Navigator from '../routes';

export default function useNavigation(): Navigator {
    const [state, updateState] = useImmer<Navigator>(new Navigator());
    return state;
}
